<template>
    <div class="newsletter-input"
         :class="{ 'newsletter-input--footer': isFooter }">
        <form class="newsletter-input__form"
              @submit.prevent="loadRecaptchaAndProceed">
            <input v-model="email"
                   class="newsletter-input__input"
                   :placeholder="getTrans('subscribe.inputPlaceholder')"
                   type="email">
            <BaseButton :id="NEWSLETTER_PAGE_BUTTON"
                        width="160px"
                        type="submit">
                <Translate translationKey="subscribe.buttonText"
                           fallback="Subscribe" />
            </BaseButton>
            <div v-if="!!errorMessage"
                 class="newsletter-input__error">
                {{ errorMessage }}
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
    import { getTrans } from '@/js/helpers/getTrans';
    import { useSubscribeForm } from '@/js/subscribe/composables/useSubscribeForm';
    import { subscriberSourceEnum } from '@/js/enums/subscriberSourceEnum';
    import BaseButton from '@/js/components/BaseButton.vue';

    const props = defineProps<{
        isFooter?: boolean;
        source?: subscriberSourceEnum;
    }>();

    const NEWSLETTER_PAGE_BUTTON = 'newsletter-page-button';
    const sources = [subscriberSourceEnum.SOURCE_NEWSLETTER];
    if (props.source !== null && props.source !== undefined) {
        sources.push(props.source);
    }

    const {
        email,
        errorMessage,
        loadRecaptchaAndProceed,
    } = useSubscribeForm(props.source, sources, NEWSLETTER_PAGE_BUTTON, true);
</script>

<style scoped lang="scss">
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/newsletter/variables" as newsletterVariables;

.newsletter-input {
    &__form {
        position: relative;
        display: flex;
        width: 100%;
    }

    &__input {
        display: flex;
        flex: 1;
        padding: 0 14px;
        border: none;
        border-radius: 10px;
        margin-right: 6px;
        outline: none;

        @media (min-width: breakpoints.$lg-breakpoint) {
            margin-right: 10px;
        }

        &::placeholder {
            color: newsletterVariables.$dark-gray-2;
        }
    }

    &__error {
        position: absolute;
        bottom: -22px;
        left: 0;
        color: variables.$error600;
        font-size: 13px;
        line-height: 19px;
    }

    &--footer {
        .newsletter-input__input {
            min-width: 180px;
            border: 1px solid rgba(variables.$baseWhite, 0.25);
            background-color: transparent;
            color: variables.$baseWhite;
            transition: border-color 200ms ease-in-out;

            &::placeholder {
                font-size: 14px;
            }

            &:focus {
                border-color: rgba(variables.$baseWhite, 0.5);
            }
        }

        @media (min-width: breakpoints.$lg-breakpoint) and (max-width: breakpoints.$xl-breakpoint) {
            .newsletter-input__form {
                display: flex;
                flex-direction: column;

                .newsletter-input__input {
                    width: 100%;
                    min-height: 48px;
                }

                button {
                    width: 100%;
                    margin-top: 16px;
                }
            }
        }
    }
}
</style>
